var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"image",staticClass:"hoverZoom",style:({ 
        'cursor':("" + (!!_vm.canClick ? 'pointer' : 'auto')), 
        'background-image': ("url(" + _vm.src + ")"), 
        width: (_vm.dwidth + "px"), 
        height: (_vm.dheight + "px"), 
        // 'max-height': `${maxHeight}px`,
        // 'max-width': `${maxWidth}px` 
    }),on:{"click":_vm.click}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }